import { getTimezoneOffset } from 'date-fns-tz';
import PropTypes from 'prop-types';

const endDate = (date, current) => {
  if (current) {
    return 'Present';
  }

  if (date) {
    const dateArray = date.split('-').map((x) => Number(x));
    // Subtracted 1 to get the correct month
    return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }
  return null;
};

// .getDay() returns an int in [0..6]. 0 is Sunday, 6 is Saturday.
// so weekdays are the days for which .getDay() % 6 is non-zero.
export const isWeekday = (date) => (date.getDay() % 6) !== 0;

// calculates numBusinessDays (int) after the given initialDate (Date)
export const businessDaysAfter = (initialDate, numBusinessDays) => {
  const date = new Date(initialDate);

  let daysLeft = numBusinessDays;
  while (daysLeft) {
    date.setDate(date.getDate() + 1);
    if (isWeekday(date)) {
      daysLeft -= 1;
    }
  }

  return date;
};

const MS_PER_HOUR = 60 * 60 * 1000;

// e.g., "America/New_York" => "America/New York - (GMT-4:00)"
export const timezoneStringLabel = (tzStr, currentDate = new Date()) => {
  if (tzStr === 'seperator') {
    return tzStr;
  }
  const offsetInMS = getTimezoneOffset(tzStr, currentDate);

  const offsetInHours = offsetInMS / MS_PER_HOUR;
  const min = Math.abs(offsetInHours * 60);
  const minStr = min % 60 === 0 ? '00' : min % 60;
  const hrStr = Math.trunc(min / 60);
  const signStr = offsetInHours >= 0 ? '+' : '-';
  const offsetTimeStr = `${signStr}${hrStr.toString().padStart(2, '0')}:${minStr}`;
  // e.g. offsetTimeStr = +4:30 or -2:00

  let tzLocality = tzStr.replace(/_/g, ' '); // replacing underscores with spaces
  tzLocality = tzLocality.replace('/', '-');
  return `${tzLocality}  (GMT${offsetTimeStr})`;
};

export const interviewAvailabilityShape = PropTypes.shape({
  date: PropTypes.string.isRequired,
  start_time: PropTypes.string.isRequired,
  end_time: PropTypes.string.isRequired,
});

export const date = (start, end, current) => {
  let startDateString = null;
  if (start) {
    const startDate = start.split('-').map((x) => Number(x));
    // Subtracted 1 to get the correct month
    startDateString = new Date(startDate[0], startDate[1] - 1, startDate[2]).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }
  const endDateString = endDate(end, current);
  if (startDateString || endDateString) {
    return `${startDateString || ''} - ${endDateString || ''}`;
  }
  return null;
};

export default date;
